'use client';

import { useEffect, useState } from 'react';

import { getCookie, setCookie } from '@/utils';

const COOKIE_CONSENT_NAME = 'cookie-consent';
const COOKIE_CONSENT_EXPIRY_DAYS = 365;
const COOKIES_POLICY_LINK = '/politica-de-privacidade#termos-de-uso-cookies';
const PRIVACY_POLICY_LINK = '/politica-de-privacidade#privacidade';
const COOKIES_PREFERENCES_LINK = '/politica-de-cookies';

type UseCookieConsentReturn = {
  isVisible: boolean;
  isMounted: boolean;
  handleAccept: () => void;
  handleReject: () => void;
  cookiesPolicyLink: string;
  privacyPolicyLink: string;
  cookiesPreferencesLink: string;
};

export const useCookieConsent = (): UseCookieConsentReturn => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    const consent = getCookie<{ accepted: boolean }>(COOKIE_CONSENT_NAME);

    if (!consent?.accepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie(
      COOKIE_CONSENT_NAME,
      { accepted: true },
      {
        maxAge: COOKIE_CONSENT_EXPIRY_DAYS * 24 * 60 * 60,
        sameSite: 'lax',
      },
    );
    setIsVisible(false);
  };

  const handleReject = () => {
    setCookie(
      COOKIE_CONSENT_NAME,
      { accepted: false },
      {
        maxAge: COOKIE_CONSENT_EXPIRY_DAYS * 24 * 60 * 60,
        sameSite: 'lax',
      },
    );
    setIsVisible(false);
  };

  return {
    isVisible,
    isMounted,
    handleAccept,
    handleReject,
    cookiesPolicyLink: COOKIES_POLICY_LINK,
    privacyPolicyLink: PRIVACY_POLICY_LINK,
    cookiesPreferencesLink: COOKIES_PREFERENCES_LINK,
  };
};
